import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'dbs-pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['./pdf-preview.component.scss'],
})
export class PdfPreviewComponent implements OnInit, OnDestroy {
  fileName: string;
  pdfSrc: string;

  private onDestroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
  ) {
    this.route.params.pipe(takeUntil(this.onDestroy$), distinctUntilChanged()).subscribe(() => {
      const resolveData = this.route.snapshot.data.resolveData || {};
      if (resolveData) {
        this.pdfSrc = resolveData.attachmentUrl || '';
        this.fileName = resolveData.fileName || '';
      }
    });
  }

  ngOnInit() {
    if (this.pdfSrc && this.fileName && this.cdr && !(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }
}
